(function () {
  'use strict';

  function initDrawer() {
    var burger   = document.getElementById('lrn-burger');
    var drawer   = document.getElementById('lrn-mobile-drawer');
    var overlay  = document.getElementById('lrn-drawer-overlay');
    var closeBtn = document.getElementById('lrn-drawer-close');

    if (!burger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lrn-drawer-open');
      burger.setAttribute('aria-label', 'Fermer le menu');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lrn-drawer-open');
      burger.setAttribute('aria-label', 'Ouvrir le menu');
    }

    burger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
        burger.focus();
      }
    });
  }

  function initMobileSubmenus() {
    document.querySelectorAll('.lrn-mobile-link--toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group   = toggle.closest('.lrn-drawer-group');
        var submenu = group ? group.querySelector('.lrn-mobile-submenu') : null;
        if (!submenu) return;
        var isOpen = submenu.classList.contains('is-open');
        document.querySelectorAll('.lrn-mobile-submenu.is-open').forEach(function (s) {
          s.classList.remove('is-open');
          var t = s.closest('.lrn-drawer-group').querySelector('.lrn-mobile-link--toggle');
          if (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
        });
        if (!isOpen) {
          submenu.classList.add('is-open');
          toggle.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initDropdowns() {
    document.querySelectorAll('.lrn-nav-dropdown-wrap').forEach(function (wrap) {
      var btn      = wrap.querySelector('.lrn-nav-link--has-dropdown');
      var dropdown = wrap.querySelector('.lrn-nav-dropdown');
      if (!btn || !dropdown) return;

      btn.addEventListener('click', function () {
        var isOpen = wrap.classList.contains('is-open');
        document.querySelectorAll('.lrn-nav-dropdown-wrap.is-open').forEach(function (w) {
          w.classList.remove('is-open');
          w.querySelector('.lrn-nav-link--has-dropdown').setAttribute('aria-expanded', 'false');
          w.querySelector('.lrn-nav-dropdown').setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          dropdown.setAttribute('aria-hidden', 'false');
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
        }
      });

      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          wrap.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
          btn.focus();
        }
      });
    });
  }

  function initTicker() {
    var ticker = document.getElementById('lrn-ticker');
    if (!ticker) return;
    var items = ticker.querySelectorAll('.lrn-ticker-item:not([aria-hidden])');
    if (items.length < 4) {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        ticker.appendChild(clone);
      });
    }
  }

  function initStickyNav() {
    var nav = document.querySelector('.lrn-nav');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 10 ? '0 1px 12px rgba(0,0,0,0.06)' : 'none';
    }, { passive: true });
  }

  function init() {
    initDrawer();
    initMobileSubmenus();
    initDropdowns();
    initTicker();
    initStickyNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.lrn-hero') || e.target.querySelector('.lrn-nav')) init();
  });

})();